"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6943],{

/***/ 16943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionHighlights": function() { return /* binding */ SectionHighlights; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "$48",
    containerSpace: "medium",
    "@md": {
        alignItems: "flex-start"
    },
    "@lg": {
        alignItems: "center",
        gap: "$64",
        paddingInline: "$30"
    }
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("h2", {
    projectFont: "heading04",
    color: "$white",
    textAlign: "left",
    margin: 0,
    fontSize: "36px",
    "@lg": {
        textAlign: "center"
    }
});
const HighlightsWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("ul", {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "$40",
    width: "100%",
    margin: 0,
    padding: 0,
    listStyle: "none",
    justifyItems: "start",
    "@md": {
        maxWidth: "840px"
    },
    "@lg": {
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "$64",
        maxWidth: "1168px",
        justifyItems: "center"
    }
});
const Highlight = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("li", {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "$16",
    color: "$white",
    "@lg": {
        maxWidth: "345px"
    }
});
const HighlightTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("h3", {
    projectFont: "ui02",
    color: "$white",
    width: "max-content",
    maxWidth: "100%",
    margin: 0,
    padding: "$8 $16",
    borderRadius: "$rMax",
    backgroundColor: "$white_005"
});
const HighlightDescription = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "heading08",
    color: "$white",
    margin: 0
});
const SectionHighlights = (param)=>{
    let { title , highlights , spacing , topBorder  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: spacing,
        topBorder: topBorder,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                children: title
            }),
            highlights && highlights.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HighlightsWrap, {
                children: highlights.map((param)=>{
                    let { _key , title , description  } = param;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Highlight, {
                        children: [
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HighlightTitle, {
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HighlightDescription, {
                                children: description
                            })
                        ]
                    }, _key);
                })
            })
        ]
    });
};


/***/ })

}]);